<template>
  <div>
    <div
      class="take-photo-container bordered border-light rounded p-1 text-center d-flex align-items-center justify-content-center"
    >
      <div v-if="!dataItem.id">
        <div>
          <FeatherIcon
            icon="CameraIcon"
            size="36"
            class="text-primary"
          />
        </div>
        <div class="mt-2">
          <b-button
            variant="flat-primary"
            pill
            @click="toggleModal"
          >
            Fotoğraf Yükle
          </b-button>
        </div>
      </div>
      <div>
        <b-img
          :src="dataItem.thumb"
          fluid-grow
        />
      </div>
    </div>
    <div
      v-if="removeAble"
      class="mt-n2 text-center"
    >
      <b-button
        variant="danger"
        pill
        @click="removePhoto(itemIndex)"
      >
        <FeatherIcon icon="TrashIcon" /> Fotoğrafı Sil
      </b-button>
    </div>
    <b-modal
      v-model="uploadModal"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      title="Fotoğraf Yükle"
      centered
      size="lg"
    >
      <div>
        <div class="mb-1">
          <div class="take-photo-container rounded d-flex align-items-center justify-content-center">
            <div
              v-if="!imageSrc"
              class="text-center w-100"
            >
              <FeatherIcon
                icon="CameraIcon"
                size="36"
              />
              <div class="text-center mt-1 font-medium-2">
                Yüklemek için bir fotoğraf çekin veya galerinizden bir fotoğraf seçin.
              </div>
            </div>
            <div v-else>
              <b-img
                :src="imageSrc"
                fluid-grow
              />
            </div>
          </div>
        </div>
        <b-alert
          v-if="uploading"
          show
          variant="info"
        >
          <div class="alert-body text-center py-1">
            <div>
              <b-spinner />
            </div>
            <div>
              Fotoğraf yükleniyor. Lütfen bekleyiniz...
            </div>
          </div>
        </b-alert>
        <template v-else>
          <div>
            <b-form-file
              id="image-upload"
              v-model="upload_file"
              placeholder="Bir görsel seçin veya buraya bırakın..."
              drop-placeholder="Görseli buraya bırakın..."
              browse-text="Görsel Seçin"
              @change="loadImage($event)"
            />
          </div>
          <div
            class="text-center mt-1"
          >
            <b-button
              variant="success"
              pill
              @click="uploadFile"
            >
              <FeatherIcon icon="UploadIcon" /> Fotoğrafı Yükle
            </b-button>
            <div class="mt-1">
              <b-button
                variant="flat-danger"
                @click="toggleModal"
              >
                <FeatherIcon icon="XIcon" /> Vazgeç
              </b-button>
            </div>
          </div>
        </template>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {
  BButton, BModal, BFormFile, BImg, BAlert, BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'PhotoItem',
  components: {
    BButton,
    BModal,
    BFormFile,
    BImg,
    BAlert,
    BSpinner,
  },
  props: {
    dataItem: {
      type: Object,
      required: true,
    },
    itemIndex: {
      type: Number,
      required: true,
    },
    removePhoto: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      upload_file: null,
      uploadModal: false,
      imageSrc: null,
    }
  },
  computed: {
    uploading() {
      return this.$store.getters['fileUpload/uploading']
    },
    serviceWorks() {
      return this.$store.getters['serviceWorks/dataItem']
    },
    removeAble() {
      if (this.itemIndex > 2) {
        return true
      }
      if (this.dataItem.id) {
        return true
      }
      return false
    },
  },
  methods: {
    toggleModal() {
      this.imageSrc = null
      this.uploadModal = !this.uploadModal
    },
    uploadFile() {
      this.$store.dispatch('cropperUploads/uploadImage', {
        folder: 'services',
        resize: true,
        width: 1200,
        thumb: 370,
        webp: false,
        ordering: 1,
        component: 'services',
        params: 'works',
        item_id: 0,
        filename: 'service-work',
        upload_image: this.upload_file,
      })
        .then(response => {
          if (response.status) {
            this.serviceWorks.photos[this.itemIndex].id = response.data.id
            this.serviceWorks.photos[this.itemIndex].photo = response.data.file_path
            this.serviceWorks.photos[this.itemIndex].thumb = response.data.file_path_thumb
            this.toggleModal()
          }
        })
    },
    loadImage(event) {
      const file = event.target.files[0]

      if (file) {
        const reader = new FileReader()

        reader.onload = e => {
          this.imageSrc = e.target.result
        }

        reader.readAsDataURL(file)
      }
    },
  },
}
</script>
<style>
.take-photo-container{
  aspect-ratio: 16/9;
  background-color: #f1f1f1;
  width: 100%;
  height: auto;
}
</style>
